"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fs_1 = __importDefault(require("fs"));
var path_1 = __importDefault(require("path"));
/**
 * Creates directories and all subdirectories for the specified path
 * @param {string} path full path containing all the directories that need to exist
 * @param {string} root specify the absolute root from where the function should begin if {path} is relative
 */
fs_1.default.ensureDirectoryExists = function (path, root) {
    if (root === void 0) { root = ''; }
    try {
        path = path.replace(/\\/g, "/");
        var directories = path.split('/');
        var nextDirectory = directories.shift();
        root = root + nextDirectory + '/';
        if (!fs_1.default.existsSync(root))
            fs_1.default.mkdirSync(root);
        return !directories.length || fs_1.default.ensureDirectoryExists(directories.join('/'), root);
    }
    catch (_a) {
        return false;
    }
};
/**
 * Copy a file from one directory to another
 * @param {string} pathToFile the full path to the file desired to be copied
 * @param {string} toDirectory the full path to the directory for which the file should be copied
 * @returns {Promise<string>} returns a promise with a string which is the full path to the copied file
 */
fs_1.default.copy = function (pathToFile, toDirectory) {
    return new Promise(function (res, rej) {
        if (!fs_1.default.ensureDirectoryExists(toDirectory, ''))
            rej("could not create directories to copy the file to");
        var filename = path_1.default.basename(pathToFile);
        var destinationPathToFile = path_1.default.resolve(toDirectory, filename);
        var destinationStream = fs_1.default.createWriteStream(destinationPathToFile);
        fs_1.default.createReadStream(pathToFile)
            .pipe(destinationStream)
            .on('close', function () { return res(destinationPathToFile); })
            .on('error', function (e) {
            console.error(e);
            rej(e);
        });
    });
};
